import { HEX_COLOR_REGEX } from "toptaal-shared"
import { z } from "zod"

export const organizationStyleFormSchema = z.object({
  primaryColor: z.string().regex(HEX_COLOR_REGEX, {
    message: "Kleur moet een hexadecimale waarde zijn",
  }),
  secondaryColor: z.string().regex(HEX_COLOR_REGEX, {
    message: "Kleur moet een hexadecimale waarde zijn",
  }),
})
